export const FORMAT_LIST_IMPORT_ACTIVITY: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'XLSX',
  },
  {
    id: 2,
    name: 'xls',
    label: 'XLS',
  },
  {
    id: 3,
    name: 'csv',
    label: 'CSV',
  },
];

export const FORMAT_LIST_EXPORT_ACTIVITY: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'Excel Spreadsheet (XLSX)',
  },
  {
    id: 2,
    name: 'csv',
    label: 'Comma-Separated Values (CSV)',
  },
];

export const FORMAT_LIST_IMPORT_ASSET: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'XLSX',
  },
  {
    id: 2,
    name: 'xls',
    label: 'XLS',
  },
  {
    id: 3,
    name: 'csv',
    label: 'CSV',
  },
];

export const FORMAT_LIST_EXPORT_ASSET: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'Excel Spreadsheet (XLSX)',
  },
  {
    id: 2,
    name: 'csv',
    label: 'Comma-Separated Values (CSV)',
  },
];

export const FORMAT_LIST_IMPORT_CONTACT: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'XLSX',
  },
  {
    id: 2,
    name: 'xls',
    label: 'XLS',
  },
  {
    id: 3,
    name: 'csv',
    label: 'CSV',
  },
];

export const FORMAT_LIST_EXPORT_CONTACT: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'Excel Spreadsheet (XLSX)',
  },
  {
    id: 2,
    name: 'csv',
    label: 'Comma-Separated Values (CSV)',
  },
];

export const FORMAT_LIST_IMPORT_DEAL: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'XLSX',
  },
  {
    id: 2,
    name: 'xls',
    label: 'XLS',
  },
  {
    id: 3,
    name: 'csv',
    label: 'CSV',
  },
];

export const FORMAT_LIST_EXPORT_DEAL: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'Excel Spreadsheet (XLSX)',
  },
  {
    id: 2,
    name: 'csv',
    label: 'Comma-Separated Values (CSV)',
  },
];

export const FORMAT_LIST_IMPORT_DEAL_TABLE: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'XLSX',
  },
  {
    id: 2,
    name: 'xls',
    label: 'XLS',
  },
  {
    id: 3,
    name: 'csv',
    label: 'CSV',
  },
];

export const FORMAT_LIST_EXPORT_DEAL_TABLE: FormatItem[] = [
  {
    id: 1,
    name: 'xlsx',
    label: 'Excel Spreadsheet (XLSX)',
  },
  {
    id: 2,
    name: 'csv',
    label: 'Comma-Separated Values (CSV)',
  },
];

export const FORMAT_LIST_EXPORT_DEAL_FILES_TABLE: FormatItem[] = [
  {
    id: 1,
    name: 'zip',
    label: 'Archive (Zip)',
    description: 'This format will include files only',
  },
  {
    id: 2,
    name: 'xlsx',
    label: 'Excel Spreadsheet (XLSX)',
  },
  {
    id: 3,
    name: 'csv',
    label: 'Comma-Separated Values (CSV)',
  },
];

export const FORMAT_LIST_IMPORT_SETTINGS: FormatItem[] = [
  {
    id: 1,
    name: 'json',
    label: 'JSON',
  },
];

export const FORMAT_LIST_POWER_BI_TEMPLATE: FormatItem[] = [
  {
    id: 1,
    name: 'pbit',
    label: 'Power BI Template',
  },
];
